import {useState, useEffect} from "react"

import {wrappedGet} from "../utilities/AxiosHelper"

export const PreceptorFromApi = ({num = -1, stmt, value}) => {
    const [apiValue, setApiValue] = useState("")
    useEffect(() => {
        let cancelled = false   
        wrappedGet("/preceptors")
            .then((response) => {   
                if (cancelled) return
                const results = response.data.results ?? []
                const item = results.find((f) => f.id === Number.parseInt(value))
                setApiValue(item?.name ?? "Unknown")
            })
            .finally(() => {
                cancelled = true
            })
        return () => {
            cancelled = true
        }
    }, [])

    return (
        <div className="d-flex flex-row align-items-center fs-5 gap-4">
            <div className="flex-grow-1">
                <div className="d-flex ">
                    {num !== -1 && (
                        <div className="d-flex flex-column">
                            <div className="symbol symbol-30px me-4">
                                <div className="symbol-label fs-5 fw-semibold bg-primary text-inverse-danger">
                                    {num}
                                </div>
                            </div>
                        </div>
                    )}
                    <span className="d-flex flex-column pt-1">
                        <div className="d-flex flex-row fw-bold">{stmt}</div>
                        <div className="d-flex flex-row mt-2">{apiValue}</div>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default PreceptorFromApi
